import BasicInformationNew from "./BasicInformationNew";

export default BasicInformationNew;
